module.exports = __webpack_public_path__ + "img/depmap_svg_V43.5e1db2aa.svg";